<template>
    <!-- 人员信息 -->
    <div class="list">
        <!-- <span class="tips">提示：录入保单的人员清单，仅为新契约中的人员</span> -->
        <div class="search-box">
            <div class="input-item">
                <span class="label">姓名</span>
                <Input v-model="name" placeholder="请输入" clearable />
            </div>
            <div class="btn-item">
                <Button type="primary" @click="searchPersonnelList()">搜索</Button>
                <Button type="warning" @click="$refs.personnelListRef.open({}, policyNo)">新增</Button>
                <Button type="primary" ghost @click="$refs.batchImport.open(policyNo)">导入</Button>
                <Button type="primary" ghost @click="exportExcel">导出</Button>
            </div>
        </div>

        <div class="tools-box">
            <div class="left-box">
                <Checkbox v-model="isAll" @on-change="selectAll">全部人员</Checkbox>
            </div>
            <div class="right-box">
                <span class="text"
                    >已选择<span>{{ isAll ? total : selectArr.length }}</span
                    >项,共<span>{{ total }}</span
                    >条数据</span
                >
                <Button type="primary" @click="delSelect" ghost>批量删除</Button>
            </div>
        </div>
        <div class="table-box">
            <loading :isShow="listLoading" />
            <Table :columns="personnelColumns" :data="personnelTableData" @on-selection-change="onSelectChange">
                <template slot-scope="{ row }" slot="cardNoMask">
                  <div>
                    <span v-if="!row.eyeShow1">{{ row.cardNoMask }}</span>
                    <span v-else>{{ row.cardNoMask1 }}</span>
                    <span v-if="row.cardNoMask">
                      <i class="iconfont iconxianshi eye-icon" v-if="row.eyeShow1" @click="openEye(row, 'eyeShow1', 'cardNoMask')"></i>
                      <i class="iconfont iconyincang eye-icon" v-else @click="openEye(row, 'eyeShow1', 'cardNoMask')"></i>
                    </span>
                  </div>
                </template>
                <template slot-scope="{ row }" slot="action">
                    <div>
                        <span class="table-btn" @click="editPersonnelList(row)">编辑</span>
                        <span class="table-btn" @click="deletePersonnelList(row)">删除</span>
                    </div>
                </template>
            </Table>
        </div>
        <Page :total="total" :current="pageNum" :page-size="pageSize" show-total @on-change="pageChange" style="text-align: center" />

        <!-- 新增-编辑人员清单 -->
        <personnelListForm ref="personnelListRef" @success="getPersonneList();isAll=false;"></personnelListForm>

        <!-- 批量导入 -->
        <batchImport ref="batchImport" @upload-success="getPersonneList();isAll=false;" :type="1"></batchImport>
    </div>
</template>

<script>
import personnelListForm from '../components/personnelListForm';
import batchImport from '../components/batchImport';
import filter from '@/api/filter';
import { pageTool, common } from '@/api/mixins';
export default {
    mixins: [pageTool,common],
    name: 'personnelInfoList',
    props: ['policyNo'],
    components: {
        personnelListForm,
        batchImport
    },
    data() {
        return {
            listLoading: false,
            name: '',
            total: 0,
            pageNum: 1,
            pageSize: 10,
            personnelTableData: [],
            personnelColumns: [
                {
                    type: 'selection',
                    width: 60,
                    align: 'center'
                },
                {
                    title: '姓名',
                    key: 'name',
                    minWidth: 150,
                    align: 'center'
                },
                {
                    title: '证件号',
                    minWidth: 180,
                    align: 'center',
                    slot: 'cardNoMask',
                },
                {
                    title: '证件类型',
                    key: 'cardType',
                    minWidth: 180,
                    align: 'center',
                    render(h, params) {
                        let cardType = params.row.cardType;
                        return <span>{cardType ? filter.filterCardType(cardType) : '-'}</span>;
                    }
                },
                {
                    title: '职业类别',
                    key: 'jobGrade',
                    minWidth: 180,
                    align: 'center',
                    render(h, params) {
                        const jobGrade = params.row.jobGrade;
                        return <span>{jobGrade ? jobGrade : '-'}</span>;
                    }
                },
                {
                    title: '职业名称',
                    key: 'jobName',
                    minWidth: 180,
                    align: 'center',
                    render(h, params) {
                        const jobName = params.row.jobName;
                        return <span>{jobName ? jobName : '-'}</span>;
                    }
                },
                {
                    title: '职业编码',
                    key: 'jobCode',
                    minWidth: 180,
                    align: 'center',
                    render(h, params) {
                        const jobCode = params.row.jobCode;
                        return <span>{jobCode ? jobCode : '-'}</span>;
                    }
                },
                {
                    title: '保障计划',
                    key: 'planName',
                    minWidth: 180,
                    align: 'center',
                    render(h, params) {
                        const planName = params.row.planName;
                        return <span>{planName ? planName : '-'}</span>;
                    }
                },
                {
                    title: '操作',
                    slot: 'action',
                    align: 'center',
                    width: '180',
                    fixed: 'right'
                }
            ],
            selectArr: [], //选中的产品code
            isAll: false
        };
    },
    methods: {
      openEye(item,keyName,name){
        if (!item[keyName]) {
          this.descrypt(
            {
              query: item.id,
              operationFunction: 19,
              operationType: 1
            },
            item,
            name + '1',
            'order_50_1'
          ).then(() => {
            this.$set(item, keyName, true);
          });
        } else {
          this.$set(item, keyName, false);
        }
      },
        setData() {
            if(!this.policyNo){
                return;
            }
            this.getPersonneList();
        },

        // 导出
        exportExcel() {
            this.listLoading = true;
            this.$http({
                url: '/buz/grouppolicy/page/insures/export',
                type: 'POST',
                responseType: 'blob',
                data: {
                    pageSize: this.pageSize,
                    pageNo: this.pageNum,
                    // filterEndorsement: 1,
                    name: this.name,
                    policyNo: this.policyNo
                }
            })
                .then(res => {
                    this.listLoading = false;
                    this.$units.daochu(res);
                })
                .catch(e => {
                    this.listLoading = false;
                });
        },

        // 获取列表
        getPersonneList() {
            this.listLoading = true;
            this.$http({
                url: '/buz/grouppolicy/page/insures',
                type: 'POST',
                data: {
                    pageSize: this.pageSize,
                    pageNo: this.pageNum,
                    // filterEndorsement: 1,
                    name: this.name,
                    policyNo: this.policyNo
                }
            })
                .then(res => {
                    res.data.forEach(item => {
                    this.selectArr.forEach(item2 => {
                        if (item.id == item2.id) {
                        item._checked = true;
                        }
                    })
                    if (this.isAll) {
                        item._checked = true;
                        item._disabled = true;
                    }
                    })
                    this.listLoading = false;
                    this.personnelTableData = res.data;
                    this.total = res.total;
                })
                .catch(e => {
                    this.listLoading = false;
                });
        },

        // 搜索
        searchPersonnelList() {
            this.pageNum = 1;
            this.getPersonneList();
        },

        // 编辑人员清单
        editPersonnelList(row) {
            this.$refs.personnelListRef.open(
                {
                    id: row.id,
                    name: row.name,
                    cardNo: row.cardNoMask,
                    jobGrade: row.jobGrade,
                    planName: row.planName,
                    jobName: row.jobName,
                    jobCode: row.jobCode
                },
                this.policyNo
            );
        },

        // 全选
        selectAll(status) {
            const personnelTableData = JSON.parse(JSON.stringify(this.personnelTableData));
            personnelTableData.forEach(item => {
                item._disabled = status;
                item._checked = status;
            });
            this.personnelTableData = personnelTableData;
            this.selectArr = [];
        },

        // 批量删除
        delSelect() {
            if (this.selectArr.length == 0 && !this.isAll) {
                this.$notice.msg('请至少选择一个人员');
                return;
            }
            this.$notice.inquiry('确定删除吗？').then(() => {
                this.delAjax(this.selectArr);
            });
        },

        // 批量删除人员请求
        delAjax(ids) {
            this.$http({
                url: '/buz/grouppolicy/delPolicyInsures',
                type: 'POST',
                data: {
                    policyNo: this.policyNo,
                    insureIds: ids,
                    type: this.isAll ? 1 : 2,
                    name: this.name
                }
            }).then(res => {
                this.$notice.success('删除成功');
                this.getPersonneList();
                this.isAll = false;
                this.selectArr = [];
            });
        },

        // 删除人员清单
        deletePersonnelList(row) {
            this.$Modal.confirm({
                title: '确定删除吗？',
                onOk: () => {
                    this.$http({
                        url: `/buz/grouppolicy/enter/insures/delete`,
                        type: 'GET',
                        data: {
                            id: row.id
                        }
                    }).then(res => {
                        this.$notice.success('删除成功');
                        this.getPersonneList();
                    });
                },
                onCancel: () => {}
            });
        },

        onSelectChange(selectArr) {
            this.selectArr = selectArr.map(item => {
                return item.id;
            });
        },

        //分页切换页码
        pageChange(pageNum) {
            this.pageNum = pageNum;
            this.getPersonneList();
        }
    }
};
</script>

<style lang="scss" scoped>
.list {
    margin-bottom: 20px;
    .tips {
        color: #515a6e;
        display: block;
        font-size: 14px;
    }
    .title {
        color: #3c464f;
        font-size: 16px;
        font-weight: bold;
    }
    .search-box {
        padding: 10px 0px 0px 0px;
    }
    .add-btn {
        margin: 10px 0 20px 0;
    }
}
.eye-icon {
    cursor: pointer;
    margin-left: 5px;
  }
</style>
